import { NavbarMenu, updateNavbar } from './app/navbar-menu';
import { updateUpper } from './app/upper';
import { CorpForm } from './app/form';
import { ImageLoader } from './app/image';
import { SearchBlock } from './app/searchBlock';

var corp = {
  navbarMenu: function (submenu: HTMLElement, popper: HTMLElement) {
    return new NavbarMenu(submenu, popper);
  },

  updateNavbar: updateNavbar,
  updateUpper: updateUpper,

  initForm: function (form: HTMLElement) {
    return new CorpForm(form);
  },

  initImageLoader: () => new ImageLoader(),
  initSearchBlock: () => new SearchBlock()
};

const _global = (window) as any;
_global.corp = corp;